module.exports = __webpack_public_path__ + "static/img/riserveOmbra.ac29085.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/products/riserveOmbra.jpg
// module id = dfeP
// module chunks = 1